import { render, staticRenderFns } from "./matchInfo.vue?vue&type=template&id=1c4a2bc8&scoped=true&"
import script from "./matchInfo.vue?vue&type=script&lang=js&"
export * from "./matchInfo.vue?vue&type=script&lang=js&"
import style0 from "./matchInfo.vue?vue&type=style&index=0&id=1c4a2bc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4a2bc8",
  null
  
)

export default component.exports